$bog_quiz_session_play $mol_page
	session_id \
	title <= session_title \
	body <= state_body /
	Waiting_view $mol_list
		rows /
			<= Waiting_text $mol_paragraph
				title @ \Waiting for quiz to start...
	Question_view $mol_list
		rows /
			<= Question_text $mol_paragraph
				title <= question_text \
			<= Timer_text $mol_paragraph
				title <= timer_text \
			<= Options_list $mol_list
				rows <= option_rows /
			<= Submit_button $mol_button_major
				click?event <=> submit_answer?event null
				title @ \Submit Answer
				enabled <= can_submit false
	Review_view $mol_list
		rows /
			<= Review_text $mol_paragraph
				title @ \Reviewing answers...
			<= Your_answer $mol_paragraph
				title <= your_answer_text \
			<= Correct_answer $mol_paragraph
				title <= correct_answer_text \
			<= Score_text $mol_paragraph
				title <= score_text \
	Finished_view $mol_list
		rows /
			<= Finished_text $mol_paragraph
				title @ \Quiz finished!
			<= Final_score $mol_paragraph
				title <= final_score_text \
			<= Leaderboard_section $mol_section
				title @ \Leaderboard
				content /
					<= Leaderboard $mol_list
						rows <= leaderboard_rows /
	Option_button* $mol_button
		click?event <=> option_toggle*?event null
		title <= option_text* \
		style * background <= option_background* \
	Leaderboard_item* $mol_view
		sub /
			<= Leaderboard_text* $mol_paragraph
				title <= leaderboard_item_text* \
